import React, { useContext } from "react";
import { Flex, Layout } from "antd";
import {
  HeaderComp,
  TwoColumnsTextLeft,
  PostList,
  FooterComp,
  CarouselComp
} from "../../../components";
import useIsMobile from '../../../utils/isMobile';
import { LangContext } from "../../../utils/LanguageProvider";
const { Header, Content, Footer } = Layout

const Press = () => {
  const { lang } = useContext(LangContext);
  const isMobile = useIsMobile();
  return (
    <>
      <Header>
        <div className="header-container">
          <HeaderComp />
        </div>
      </Header>
      <div className="full-container">
        <Flex vertical style={{ maxWidth: '1400px', width: '100%' }}>
          <Content className="global-content">
            <TwoColumnsTextLeft page={"prensa"} section={"twocolumnstextleft-hero"} lang={lang} />
            {!isMobile ? (
              <>
                <PostList page={"prensa"} section={'postlist'} numPosts={9} categoryName={'prensa'} lang={lang} />
              </>
            ) : (
              <>
                <CarouselComp page={"prensa"} section={"postlist"} type={'posts'} numPosts={9} categoryName={'prensa'} buttons={true} lang={lang} />
              </>
            )}
          </Content>
        </Flex>
      </div>
      <Footer>
        <FooterComp page={'prensa'} lang={lang} />
      </Footer>
    </>
  );
}

export default Press